const MuchLess = [
    {id: "0", value: "多轉空"},    
    {id: "1", value: "空轉多"}
  ];  
  
  export default MuchLess